(function() {
    'use strict';

    angular
        .module('app.campaignInfluencersManagePage')
        .factory('viewCampaignInfoService', ['CampaignFormService', 'campaignInfluencersManagePageService', 'advertisersManagementService',
            function (CampaignFormService, campaignInfluencersManagePageService, advertisersManagementService) {

                return {
                    acceptCampaign: campaignInfluencersManagePageService.acceptCampaign,
                    rejectCampaign: campaignInfluencersManagePageService.rejectCampaign,
                    getCampaign: CampaignFormService.getCampaign,
                    getAdvertiser: advertisersManagementService.getAdvertiser,
                    getCampaignTermsForInfluencer: CampaignFormService.getCampaignTermsForInfluencer,
                    getCampaignFiles: CampaignFormService.getCampaignFiles,
                    getUploadedFileUrl: CampaignFormService.getUploadedFileUrl,
                };
            }
        ]);
})();